import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = 'https://pinballscoresapp-ayd8babtd4fpadec.eastus2-01.azurewebsites.net';

export default function EditPlayers({ isAdmin }) {
  const [players, setPlayers] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const [formData, setFormData] = useState({ name: '', initials: '', email: '', iconUrl: '' });
  const [playerScores, setPlayerScores] = useState([]);

  const handleScoreDelete = (scoreId) => {
    if (window.confirm('Are you sure you want to delete this score?')) {
      axios.delete(`${API_BASE}/api/scores/${scoreId}`)
        .then(() => {
          alert('Score deleted');
          // Refresh scores after deletion
          axios.get(`${API_BASE}/api/scores?playerId=${parseInt(selectedPlayerId)}`)
            .then((res) => setPlayerScores(res.data));
        })
        .catch((err) => {
          console.error('Error deleting score:', err);
          alert('Error deleting score');
        });
    }
  };

  useEffect(() => {
    axios.get(`${API_BASE}/api/players`).then((res) => {
      setPlayers(res.data);
    });
  }, []);


  useEffect(() => {
    if (selectedPlayerId) {
      console.log(`Selected Player ID: ${selectedPlayerId}`);
      const player = players.find((p) => p.PlayerID === parseInt(selectedPlayerId));
      if (player) {
        console.log('Selected Player:', player);
        setFormData({
          name: player.Name || '',
          initials: player.Initials || '',
          email: player.Email || '',
          iconUrl: player.IconUrl || '',
        });

        const playerId = parseInt(selectedPlayerId);
        axios.get(`${API_BASE}/api/scores?playerId=${playerId}`)
          .then((res) => {
            console.log('Fetched Scores:', res.data);
            setPlayerScores(res.data);
          })
          .catch((err) => {
            console.error('Error fetching scores:', err);
          });
      }
    } else {
      setPlayerScores([]);
    }
  }, [selectedPlayerId, players]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleScoreChange = (index, field, value) => {
    const updatedScores = [...playerScores];
    updatedScores[index][field] = value;
    setPlayerScores(updatedScores);
  };

  const handleSave = () => {
    axios.put(`${API_BASE}/api/players/${selectedPlayerId}`, formData)
      .then(() => alert('Player updated successfully'))
      .catch((err) => alert('Error updating player'));
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this player?')) {
      axios.delete(`${API_BASE}/api/players/${selectedPlayerId}`)
        .then(() => {
          alert('Player deleted');
          setSelectedPlayerId(null);
          setFormData({ name: '', initials: '', email: '', iconUrl: '' });
          axios.get(`${API_BASE}/api/players`).then((res) => {
            setPlayers(res.data);
          });
        })
        .catch((err) => alert('Error deleting player'));
    }
  };

  const handleAddPlayer = () => {
    axios.post(`${API_BASE}/api/players`, formData)
      .then(() => {
        alert('Player added');
        setFormData({ name: '', initials: '', email: '', iconUrl: '' });
        axios.get(`${API_BASE}/api/players`).then((res) => {
          setPlayers(res.data);
        });
      })
      .catch((err) => alert('Error adding player'));
  };

  const handleScoreSave = (score) => {
    axios.put(`${API_BASE}/api/scores/${score.ScoreID}`, {
      score: score.Score,
      datePlayed: score.DatePlayed,
      isVerified: score.IsVerified
    })
      .then(() => alert('Score updated'))
      .catch((err) => alert('Error updating score'));
  };

  if (!isAdmin) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You must be authenticated as an admin to view this page.</p>
        <a href="/?admin">Go to Home & Log In</a>
      </div>
    );
  }

  return (
    <div className="edit-players" style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <h2 style={{ fontFamily: "'DotMatrix', sans-serif" }}>Edit Players</h2>

      <label style={{ fontWeight: 600 }}>Select Player:</label>
      <select value={selectedPlayerId || ''} onChange={(e) => setSelectedPlayerId(e.target.value)} style={{ fontFamily: 'inherit' }}>
        <option value="">-- Select a player --</option>
        {players.map((player) => (
          <option key={player.PlayerID} value={player.PlayerID}>
            {player.Name} ({player.Initials})
          </option>
        ))}
      </select>

      <div className="player-form">
        <label>Name:</label>
        <input name="name" value={formData.name} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Initials:</label>
        <input name="initials" value={formData.initials} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Email:</label>
        <input name="email" value={formData.email} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Icon URL:</label>
        <input name="iconUrl" value={formData.iconUrl} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        {selectedPlayerId ? (
          <div style={{ marginTop: '12px' }}>
            <button onClick={handleSave}>Save Changes</button>
            <button onClick={handleDelete} style={{ marginLeft: '10px', backgroundColor: '#c0392b' }}>Delete Player</button>
          </div>
        ) : (
          <button onClick={handleAddPlayer} style={{ marginTop: '12px' }}>Add Player</button>
        )}
      </div>

      {playerScores.length > 0 && (
        <div className="player-scores" style={{ overflowX: 'auto', marginTop: '24px' }}>
          <h3 style={{ fontFamily: "'DotMatrix', sans-serif", marginBottom: '12px' }}>Scores</h3>
          <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '6px', overflow: 'hidden' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #ddd', textAlign: 'center' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left' }}>Table</th>
                <th style={{ padding: '10px 8px', width: '70px' }}>Type</th>
                <th style={{ padding: '10px 8px', width: '130px' }}>Score</th>
                <th style={{ padding: '10px 8px', width: '150px' }}>Date Played</th>
                <th style={{ padding: '10px 6px', width: '75px' }}>Verified</th>
                <th style={{ padding: '10px 6px', width: '65px' }}>Proof</th>
                <th style={{ padding: '10px 8px', width: '95px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {playerScores.map((score, index) => (
                <tr key={score.ScoreID} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 500, wordBreak: 'break-word' }}>
                    {score.TableName}
                  </td>
                  <td style={{ padding: '8px', textAlign: 'center', color: '#555' }}>
                    {score.TableType}
                  </td>
                  <td style={{ padding: '8px' }}>
                    <input
                      type="number"
                      value={score.Score}
                      onChange={(e) => handleScoreChange(index, 'Score', e.target.value)}
                      style={{ width: '100%', padding: '6px 8px', margin: 0, fontSize: '0.9em', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #ccc', fontFamily: 'inherit' }}
                    />
                  </td>
                  <td style={{ padding: '8px' }}>
                    <input
                      type="date"
                      value={score.DatePlayed ? score.DatePlayed.slice(0, 10) : ''}
                      onChange={(e) => handleScoreChange(index, 'DatePlayed', e.target.value)}
                      style={{ width: '100%', padding: '6px 8px', margin: 0, fontSize: '0.9em', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #ccc', fontFamily: 'inherit' }}
                    />
                  </td>
                  <td style={{ textAlign: 'center', padding: '8px 4px' }}>
                    <input
                      type="checkbox"
                      checked={!!score.IsVerified}
                      onChange={(e) => handleScoreChange(index, 'IsVerified', e.target.checked)}
                      style={{ margin: 0, width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                  </td>
                  <td style={{ textAlign: 'center', padding: '8px 4px' }}>
                    {score.ProofUrl ? (
                      <a
                        href={score.ProofUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="View Proof Image"
                        style={{ textDecoration: 'none', fontSize: '1.25em', display: 'inline-block' }}
                      >
                        🖼️
                      </a>
                    ) : (
                      <span style={{ color: '#bbb', fontSize: '0.9em' }}>—</span>
                    )}
                  </td>
                  <td style={{ textAlign: 'center', padding: '8px', whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'inline-flex', gap: '6px', alignItems: 'center', justifyContent: 'center' }}>
                      <button
                        onClick={() => handleScoreSave(score)}
                        title="Save"
                        style={{
                          padding: '6px 8px',
                          margin: 0,
                          minHeight: 'auto',
                          fontSize: '1em',
                          lineHeight: 1,
                          backgroundColor: '#4a7c59',
                          borderRadius: '4px'
                        }}
                      >
                        💾
                      </button>
                      <button
                        onClick={() => handleScoreDelete(score.ScoreID)}
                        title="Delete"
                        style={{
                          padding: '6px 8px',
                          margin: 0,
                          minHeight: 'auto',
                          fontSize: '1em',
                          lineHeight: 1,
                          backgroundColor: '#c0392b',
                          borderRadius: '4px'
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}